import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  link?: { label: string; to: string };
}

export default function SectionHeading({ eyebrow, title, subtitle, align = "left", link }: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-col gap-3 md:flex-row md:items-end md:justify-between ${
        align === "center" ? "text-center items-center md:flex-col md:items-center" : ""
      }`}
    >
      <div className={align === "center" ? "mx-auto max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary-800">
            <i className="ri-sparkling-2-fill"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading text-2xl md:text-4xl font-extrabold tracking-tight text-foreground-950">{title}</h2>
        {subtitle && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{subtitle}</p>}
      </div>
      {link && (
        <Link
          to={link.to}
          className="inline-flex w-fit items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-800 hover:border-primary-400 hover:bg-primary-50 whitespace-nowrap cursor-pointer"
        >
          {link.label}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}